export class AttachmentInfoModel {
    constructor() {
        this.checked = false;
    }
    id: string;
    attachmentName: string;
    score: string;
    downloadedURL: string;
    downloadedBusinessURL: string;
    iFrameURL: string;
    businessiFrameURL: string;
    bdContact: string;
    geography: string;
    logo: string;
    logoImage: string;
    projectManager: string;
    projectName: string;
    restrictedContent: boolean;
    geographyURL: string;
    tags: string[];
    base64Content: string;
    client: string;
    region: string;
    date: Date;
    flipped = false;
    viewCount: number;
    downloadCount: number;
    vertical: string;
    projectStatus: string;
    checked: boolean;
    organizationId: string;
    organization: string;
    deliveryOrganization: string;
    businessCaseStudyFlag: boolean;
    caseStudyLogo:string;
    bussinessCaseFileName: string;

}

export class AttachmentLinksModel {
    link: any;
    attachmentName: string;
}

export class SearchTypeModel {
    filterList: string[];
    groupBy: string;
    searchTerm: string;
    operator: boolean;
    activeProjectsFilter: boolean;
    displayType: string;
    vertical:string;
}
